import { SeoHeadGrammar } from '@doltech/ui/lib/figma/SeoHead/SeoHead';
import * as React from 'react';
import { GrammarLandingPageLayout } from '@doltech/domains/landing-grammar/lib/landing/GrammarLandingPageLayout';
import { GioiThieuGrammarPage } from '@doltech/domains/landing-grammar/lib/other-static-pages/GioiThieuGrammarPage';
import { getFinalUrlGrammar } from '@doltech/domains/landing-grammar/lib/shared/utils';
import {
  getLandingGrammarPageByTemplateTypes,
  getSeoPageLandingGrammarById,
} from '@doltech/domains/landing-grammar/lib/shared/apis/landing-grammar';
import { encryptData } from '@doltech/core/lib/encrypt-page-data/encryptData';
import parse from 'html-react-parser';
import { getErrorInfo } from '@doltech/utils/lib/error';
import { cacheWrap } from '@doltech/core/lib/cache/cache-manager';
import { GrammarTemplateTypeList } from '@doltech/domains/landing-grammar/lib/shared/constants';
import NextHead from 'next/head';

const SlugPageError = (error) => (
  <div>
    <pre>Response error: {JSON.stringify(error, null, 2)}</pre>
  </div>
);

const GioiThieuPage = (props) => {
  const { schemaScriptString } = props;

  const { schema, error } = React.useMemo(() => {
    let localSchemaScript;
    let localError;
    if (schemaScriptString) {
      try {
        localSchemaScript = parse(schemaScriptString);
      } catch (ex) {
        localError = ex;
      }
    }
    return {
      schema: localSchemaScript,
      error: localError,
    };
  }, [schemaScriptString]);

  if (error) {
    return <SlugPageError error={getErrorInfo(error)} />;
  }
  return (
    <>
      <NextHead>{schema}</NextHead>
      <SeoHeadGrammar
        title="Trang giới thiệu DOL Grammar"
        description="DOL Grammar cung cấp đầy đủ kiến thức về lý thuyết, bài tập, tài liệu và công cụ kiểm tra ngữ pháp tiếng Anh"
        canonical={getFinalUrlGrammar('gioi-thieu')}
        openGraph={{
          url: getFinalUrlGrammar('gioi-thieu'),
          title: 'Trang giới thiệu DOL Grammar',
          description:
            'DOL Grammar cung cấp đầy đủ kiến thức về lý thuyết, bài tập, tài liệu và công cụ kiểm tra ngữ pháp tiếng Anh',
        }}
      />
      <GrammarLandingPageLayout {...props}>
        <GioiThieuGrammarPage {...props} />
      </GrammarLandingPageLayout>
    </>
  );
};
export default GioiThieuPage;
const buildSEOInfo = ({ urlInfo }) => {
  return {
    schemaScriptString: urlInfo?.google?.schemaHtml || '',
  };
};
export const getServerSideProps = async (context) => {
  const { res } = context;

  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=1800');
  // config api
  const { data: rawPageData } = await getSeoPageLandingGrammarById('gioi-thieu');
  const { schemaScriptString } = buildSEOInfo({ urlInfo: rawPageData });

  const { data: otherUrlInfo } = await cacheWrap(
    `getLandingGrammarPageByTemplateTypes_${JSON.stringify(GrammarTemplateTypeList)}`,
    async () => {
      return getLandingGrammarPageByTemplateTypes(GrammarTemplateTypeList);
    }
  );
  return {
    props: encryptData({
      schemaScriptString,
      isStructuralSEO: false,
      otherUrlInfo,
    }),
  };
};
